import React from "react";
import { Grid, Box, Typography, IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function SessionTitle(props) {
  let darkMode = localStorage.getItem("darkMode") === "true" ? true : false;
  return (
    <>
      <Grid
        item
        xs={12}
        sx={{
          background: darkMode ? "#182434" : "#354d6b",
        }}
      >
        <Box mt={0.5}>
          <Typography
            variant="caption"
            sx={{
              color: "#6f85a1",
              cursor: "default",
              textAlign: "center",
              userSelect: "none",
              textTransform: "uppercase",
            }}
            display="block"
          >
            {props.title}
          </Typography>
          {/*           <IconButton
            onClick={() => props.getLayouts}
            sx={{
              top: " 43px",
              position: "absolute",
              left: "220px",
              padding: "0",
            }}
            size="small"
          >
            <RefreshIcon fontSize="inherit" />
          </IconButton> */}
        </Box>
      </Grid>
    </>
  );
}
